module.exports = __webpack_public_path__ + "img/trash.895b4d05.png";